(function () {
  'use strict';

  // State cache for cart items: { variant_id: total_quantity }
  let cartVariantMap = {};

  // Fetch current cart state
  async function fetchCartState() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
      if (!res.ok) return null;
      const cart = await res.json();
      updateCartVariantMap(cart);
      updateHeaderCartBadge(cart);
      syncAllProductCardSelectors();
      return cart;
    } catch (err) {
      console.error('Error fetching cart state:', err);
      return null;
    }
  }

  function updateCartVariantMap(cart) {
    cartVariantMap = {};
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach((item) => {
        const vId = String(item.variant_id || item.id);
        cartVariantMap[vId] = (cartVariantMap[vId] || 0) + item.quantity;
      });
    }
  }

  function getCartTargetIcon() {
    return (
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('.parksons-header__icon-link') ||
      document.querySelector('.parksons-header__cart-count') ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('a[href*="/cart"]')
    );
  }

  function animateFlyToCart(imgElement) {
    if (!imgElement) return;
    const targetCart = getCartTargetIcon();
    if (!targetCart) return;

    const imgRect = imgElement.getBoundingClientRect();
    const targetRect = targetCart.getBoundingClientRect();

    if (imgRect.width === 0 || imgRect.height === 0) return;

    const clone = imgElement.cloneNode(true);
    clone.classList.add('flying-cart-img');
    clone.style.left = `${imgRect.left}px`;
    clone.style.top = `${imgRect.top}px`;
    clone.style.width = `${imgRect.width}px`;
    clone.style.height = `${imgRect.height}px`;

    document.body.appendChild(clone);

    // Force reflow
    void clone.offsetWidth;

    // Set destination styles
    clone.style.left = `${targetRect.left + targetRect.width / 2 - 12}px`;
    clone.style.top = `${targetRect.top + targetRect.height / 2 - 12}px`;
    clone.style.width = '24px';
    clone.style.height = '24px';
    clone.style.opacity = '0.2';
    clone.style.transform = 'scale(0.2)';

    setTimeout(() => {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      targetCart.classList.remove('cart-icon-bounce');
      void targetCart.offsetWidth;
      targetCart.classList.add('cart-icon-bounce');
    }, 750);
  }

  function updateHeaderCartBadge(cartOrSections) {
    const targetCart = getCartTargetIcon();
    if (!targetCart) return;

    let count = 0;
    if (typeof cartOrSections === 'number') {
      count = cartOrSections;
    } else if (cartOrSections && typeof cartOrSections.item_count === 'number') {
      count = cartOrSections.item_count;
    } else if (cartOrSections && cartOrSections.sections && cartOrSections.sections['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartOrSections.sections['cart-icon-bubble'], 'text/html');
      const text = doc.querySelector('.cart-count-bubble span, .parksons-header__cart-count')?.textContent || doc.body.textContent;
      const parsedCount = parseInt(text.replace(/\D/g, ''), 10);
      if (!isNaN(parsedCount)) count = parsedCount;
    }

    const badges = targetCart.querySelectorAll('.parksons-header__cart-count, .cart-count-bubble');
    if (badges.length > 1) {
      for (let i = 1; i < badges.length; i++) {
        badges[i].remove();
      }
    }
    let badge = badges[0];

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'parksons-header__cart-count';
        targetCart.appendChild(badge);
      }
      badge.textContent = count < 100 ? count : '99+';
      badge.style.display = 'flex';
    } else if (badge) {
      badge.style.display = 'none';
    }
  }

  function syncAllProductCardSelectors() {
    // Only select root product card elements, avoiding nested duplicates
    const allCandidateCards = Array.from(document.querySelectorAll('article.pe-product, article.oc-product, article.pc-loved__card, article.rpc-card, [data-product-card], .card-wrapper'));
    const uniqueCards = allCandidateCards.filter((card, index, self) => {
      return !self.some((otherCard) => otherCard !== card && otherCard.contains(card));
    });

    uniqueCards.forEach((card) => {
      const variantIdInput = card.querySelector('input[name="id"]') || card.querySelector('[data-variant-id]');
      const variantId = variantIdInput ? String(variantIdInput.value || variantIdInput.dataset.variantId || '') : String(card.dataset.variantId || '');
      if (!variantId) return;

      const qtyInCart = cartVariantMap[variantId] || 0;
      updateCardUI(card, variantId, qtyInCart);
    });
  }

  function updateCardUI(cardContainer, variantId, quantity) {
    // Clean up duplicate controls if any exist
    const allControls = Array.from(cardContainer.querySelectorAll('[data-qty-control]'));
    if (allControls.length > 1) {
      allControls.slice(1).forEach((ctrl) => ctrl.remove());
    }

    let quickAddForm = cardContainer.querySelector('.pe-quick-add') || cardContainer.querySelector('.oc-quick-add') || cardContainer.querySelector('.pc-loved__quick-form') || cardContainer.querySelector('.rpc-quick-add') || cardContainer.querySelector('form[action*="/cart/add"]');
    let qtyControl = allControls[0] || null;

    const mediaContainer = cardContainer.querySelector('.pe-product__media') || cardContainer.querySelector('.oc-product__media') || cardContainer.querySelector('.pc-loved__media') || cardContainer.querySelector('.rpc-card__media') || cardContainer.querySelector('.card__media') || (quickAddForm ? quickAddForm.parentNode : cardContainer);

    if (!qtyControl) {
      qtyControl = document.createElement('div');
      qtyControl.className = 'pe-qty-control';
      qtyControl.setAttribute('data-qty-control', '');
      qtyControl.setAttribute('data-variant-id', variantId);
      qtyControl.innerHTML = `
        <button type="button" class="pe-qty-btn pe-qty-btn--minus" data-qty-minus aria-label="Decrease quantity">−</button>
        <span class="pe-qty-val" data-qty-val>${quantity}</span>
        <button type="button" class="pe-qty-btn pe-qty-btn--plus" data-qty-plus aria-label="Increase quantity">+</button>
      `;

      if (mediaContainer) {
        mediaContainer.appendChild(qtyControl);
      } else {
        cardContainer.appendChild(qtyControl);
      }
    }

    qtyControl.setAttribute('data-variant-id', variantId);
    const valEl = qtyControl.querySelector('[data-qty-val]');
    if (valEl) valEl.textContent = quantity;

    if (quantity > 0) {
      if (quickAddForm) quickAddForm.style.display = 'none';
      qtyControl.style.display = 'inline-flex';
      qtyControl.dataset.inCart = 'true';
    } else {
      if (quickAddForm) quickAddForm.style.display = '';
      qtyControl.style.display = 'none';
      qtyControl.dataset.inCart = 'false';
    }
  }

  async function handleAddToCart(form, event) {
    if (event) event.preventDefault();

    const formData = new FormData(form);
    const variantId = String(formData.get('id'));

    const card = form.closest('article.pe-product, article.oc-product, article.pc-loved__card, article.rpc-card, [data-product-card], .card-wrapper, .product-single, body');
    const img = card ? card.querySelector('.pe-product__image, .oc-product__image, .pc-loved__product-image, .rpc-card__media img, .card__media img, .product__media img, img') : null;

    // if (img) animateFlyToCart(img); // Disabled fly animation in favor of drawer

    // Check if form has items array
    let items = [];
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('items[')) {
        const match = key.match(/items\[(\d+)\]\[(id|quantity)\]/);
        if (match) {
          const index = parseInt(match[1]);
          const prop = match[2];
          items[index] = items[index] || {};
          items[index][prop] = (prop === 'id' || prop === 'quantity') ? parseInt(value) : value;
        }
      }
    }
    items = items.filter(item => item && item.id);

    try {
      let fetchOptions = {};
      
      if (items.length > 0) {
        const payload = {
          items: items,
          sections: 'cart-icon-bubble,cart-notification-product,cart-notification-button',
          sections_url: window.location.pathname
        };
        fetchOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        };
      } else {
        formData.append('sections', 'cart-icon-bubble,cart-notification-product,cart-notification-button');
        formData.append('sections_url', window.location.pathname);
        fetchOptions = {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        };
      }

      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, fetchOptions);

      const data = await res.json();
      if (res.ok) {
        updateHeaderCartBadge(data);
        const notification = document.querySelector('cart-notification');
        if (notification) {
          if (typeof notification.renderContents === 'function') {
            const notificationData = { ...data };
            if (!notificationData.key && notificationData.items && notificationData.items.length > 0) {
              notificationData.key = notificationData.items[0].key;
            }
            notificationData.keys = notificationData.items ? notificationData.items.map(item => item.key) : [notificationData.key];
            try {
              notification.renderContents(notificationData);
            } catch(e) {
              console.error('Error rendering cart notification:', e);
              if (typeof notification.open === 'function') notification.open();
            }
          } else {
            console.log('notification.renderContents is not a function, forcing open');
            const innerDiv = notification.querySelector('.cart-notification');
            if (innerDiv) {
              innerDiv.classList.add('animate', 'active');
            }
          }
        }
        await fetchCartState();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
      } else {
        console.error('Error adding to cart:', data.description || data.message);
      }
    } catch (err) {
      console.error('Cart add error:', err);
    }
  }

  async function handleQuantityChange(variantId, newQty, qtyControl) {
    if (qtyControl) qtyControl.classList.add('is-loading');

    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: newQty,
          sections: 'cart-icon-bubble'
        })
      });

      const data = await res.json();
      if (res.ok) {
        updateHeaderCartBadge(data);
        await fetchCartState();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data, bubbles: true }));
      }
    } catch (err) {
      console.error('Quantity update error:', err);
    } finally {
      if (qtyControl) qtyControl.classList.remove('is-loading');
    }
  }

  // Delegated event listeners
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) {
      // Do not duplicate requests for forms already handled by native product-form component
      if (
        form.closest('product-form') ||
        form.classList.contains('ppd-form') ||
        form.classList.contains('psn-form') ||
        form.dataset.type === 'add-to-cart'
      ) {
        return;
      }
      handleAddToCart(form, e);
    }
  });

  document.addEventListener('click', (e) => {
    const minusBtn = e.target.closest('[data-qty-minus]');
    const plusBtn = e.target.closest('[data-qty-plus]');

    if (minusBtn || plusBtn) {
      e.preventDefault();
      e.stopPropagation();

      const qtyControl = (minusBtn || plusBtn).closest('[data-qty-control]');
      if (!qtyControl) return;

      const variantId = qtyControl.dataset.variantId;
      const currentQty = cartVariantMap[variantId] || parseInt(qtyControl.querySelector('[data-qty-val]')?.textContent || '1', 10);

      if (plusBtn) {
        // const img = qtyControl.closest('article.pe-product, article.oc-product, article.pc-loved__card, article.rpc-card, [data-product-card], .card-wrapper')?.querySelector('.pe-product__image, .oc-product__image, .pc-loved__product-image, .rpc-card__media img, img');
        // if (img) animateFlyToCart(img); // Disabled fly animation
        handleQuantityChange(variantId, currentQty + 1, qtyControl);
      } else if (minusBtn) {
        handleQuantityChange(variantId, Math.max(0, currentQty - 1), qtyControl);
      }
    }
  });

  // Init on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartState);
  } else {
    fetchCartState();
  }

  window.addEventListener('pageshow', fetchCartState);
  document.addEventListener('cart:updated', fetchCartState);
  document.addEventListener('cart:refresh', fetchCartState);
})();
